import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, Table,CardHeader } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import { Accordion } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const VehicleInvoice = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);

  const [Invoice_detail, setInvoice_detail] = useState([])
  const LargeModaltoggle = () => {

    setLarge(!Large)
  };

  const [Large, setLarge] = useState(false);
  const [clientHeight, setclientHeight] = useState("")
  

 
 

  useEffect(() => {
    if (localStorage.getItem("usertype") !== "Vehicle Owner") {
      window.history.back()
    }

    getInvoiceDetail()
  }, [])

  async function getInvoiceDetail() {
    let { data: Invoice_Details, error } = await supabase
      .from('vehicle_invoice_details')
      .select('*')
      .eq("created_by", localStorage.getItem("useremail"))

    if (Invoice_Details !== null && Invoice_Details.length > 0) {
    
      setInvoice_detail(Invoice_Details)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.77)

      }, 1000)
    } else {
      if (error !== null) { }
      setInvoice_detail([])
    }
  }
  async function updateInvoice(id) {
    window.localStorage.setItem("invoice", id)
    window.location.href = "/Invoice/"+ id+`/${window.localStorage.getItem("usertype")}`

  }



  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function convertdata(tripdate) {

    var date = new Date(tripdate)
    var day_date = date.getDate()
    var month = date.getMonth()
    var day = date.getDay()


    var newdate = dayNames[day] + "-" + day_date + "-" + monthNames[month]
    return newdate
  }
  function convertdate(data) {
    var date = new Date(data)
    var day_date = date.getDate()
    var month = date.getMonth()
    var year = date.getFullYear()
    day_date = day_date < 10 ? '0' + day_date : day_date;


    var newdate = day_date + "-" + monthNames[month] + "-" + year
    return newdate
  }

 




  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Invoice Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12" id="maintrip" style={window.innerWidth<800?{paddingLeft:'5px',paddingRight:"5px"}:{width:"100%"}}>
            {window.innerWidth < 800 ? <>


              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll",padding:"5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">

                    {Invoice_detail.length > 0 ? <>
                      {Invoice_detail.map((data, i) => {
                        return (
                          <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                            <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                              <h5 className="mb-0" style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}>
                                <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>
                                      <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.vehicle_invoice_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.vehicle_invoice_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.vehicle_invoice_date).split("-")[2]}</div></div>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Bill To</span>
                                        <span style={{ display: "block" }}>{data.customer_name}</span>
                                        <span style={{ display: "block" }}>{data.customer_address}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>From</span>
                                        <span style={{ display: "block" }}>{data.man_name}</span>
                                        <span style={{ display: "block" }}>{data.man_address}</span>
                                      </div>


                                    </div>
                                  </div>



                                </Accordion.Toggle>
                                <div className="media-size-email" style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "row",
                                }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#ba78e3", padding: "10px", cursor: "pointer" }} onClick={() => {
                                  updateInvoice(data.vehicle_invoice_id)
                                }}><Icon icon="carbon:view-filled" color="#a927f9" width="20" height="20" /></div>
                                  &nbsp;




                                </div>
                              </h5>
                            </CardHeader>
                            <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                              <CardBody>
                                <div className="email-app-sidebar left-bookmark">
                                  <div className="media" style={{ alignItems: "center " }}>

                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Buyer</span>
                                      <span style={{ display: "block" }}>{data.customer_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Pick UP</span>
                                      <span style={{ display: "block" }}>{convertdate(data.pick_up)}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                      <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Transport Charges</span>
                                      <span style={{ display: "block" }}>&#8377; {data.transport_charges}</span>

                                    </div>
                                    <div className="media-body" style={{ textAlign: "left" }}>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Supplier</span>
                                      <span style={{ display: "block" }}>{data.man_name}</span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Drop Off</span>
                                      <span style={{ display: "block" }}>{convertdate(data.drop_off)} </span>
                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>License No</span>
                                      <span style={{ display: "block" }}>{data.driver_license_no} </span>

                                      <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                      <span style={{ display: "block" }}>{data.payment_status}</span>

                                    </div>


                                  </div>
                                  <br />
                                  <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {(parseInt(data.trip_amount))+(parseInt(data.transport_charges)) + (((parseInt(data.transport_charges)) * 18) / 100)}</span></p>


                                </div>


                              </CardBody>
                            </Accordion.Collapse>
                          </Card>
                        )


                      })}</> : <Card>
                      <CardHeader >
                        <h5 className="mb-0">
                          <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                            No Record Found
                          </Accordion.Toggle>
                        </h5>
                      </CardHeader>
                    </Card>}
                  </div>

                </Accordion></div>
            </> :
              <Card>


                <CardBody>
                  <div className="table-responsive ">
                    <Table>
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Date"}</th>
                          <th scope="col">{"Vehicle No"}</th>

                          <th scope="col">{"Buyer"}</th>
                          <th scope="col">{"Buyer Address"}</th>
                          <th scope="col">{"Supplier"}</th>
                          <th scope="col">{"Supplier Address"}</th>


                          <th scope="col">{"Driver"}</th>
                          <th scope="col">{"License No"}</th>


                          <th scope="col">{"Vehicle Type"}</th>
                          <th scope="col">{"Transport Distance"}</th>
                          <th scope="col">{"Transport Cost"}</th>
                          <th scope="col">{"Total Cost"}</th>

                          <th scope="col">{"Payment"}</th>
                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Invoice_detail.length > 0 ? <>
                          {Invoice_detail.map((data, i) => {
                            return (
                              <tr key={i} style={{ textAlign: "center" }}>
                                <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.vehicle_invoice_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.vehicle_invoice_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.vehicle_invoice_date).split("-")[2]}</div></div></td>
                                <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_no.substring(0, 6)}</div><div style={{ fontWeight: "700", fontSize: "19px" }}>{data.vehicle_no.substring(6, 10)}</div></div></td>


                                <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span></td>
                                <td>{data.customer_address}</td>
                                <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.man_name}</span></td>
                                <td>{data.man_address}</td>



                                <td><span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.driver_name}</span></td>
                                <td>{data.driver_license_no}</td>
                                <td>{data.vehicle_type}</td>
                                <td>{data.transport_distance}</td>
                                <td>{data.transport_charges}</td>
                                <td>{parseInt(data.trip_amount) + ((parseInt(data.trip_amount) * 18) / 100) + parseInt(data.transport_charges)}</td>
                                <td>{data.payment_status === "Paid" ? <span style={{ textTransform: "uppercase", backgroundColor: "darkgreen", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "orange", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span>}</td>

                                <td><button className='btn btn-info' onClick={() => {
                                  updateInvoice(data.vehicle_invoice_id)
                                  LargeModaltoggle();
                                }}><i className='fa fa-eye '></i> View</button></td>
                              </tr>
                            )
                          })}
                        </>
                          : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}

                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default VehicleInvoice;